import React from 'react';
import Modal, { ModalProps } from '@/components/Modal';
import Button from '@/components/Button';
import { ExclamationIcon, LinkIcon } from '@/components/Icons';
import { TDeleteAttachmentData } from '../types/DeleteAttachmentData';

interface RemoveAttachmentConfirmModalProps extends ModalProps {
  attachmentData: TDeleteAttachmentData | undefined;
  onConfirm: () => void;
}

const RemoveAttachmentConfirmModal: React.FC<RemoveAttachmentConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  attachmentData
}) => {
  return (
    <Modal isOpen={isOpen} headerText="Remove Attachment">
      <div className="p-4 flex flex-col gap-y-6">
        <div className="flex flex-col gap-y-4 text-dark-navy-30 text-sm">
          <p className="font-medium">Are you sure you wish to remove this attachment?</p>
        </div>
        <Button
          className="rounded-lg w-full justify-start min-h-12 h-auto cursor-default"
          childrenClassName="w-full py-0"
          variant={'secondary_alternative'}>
          <span>
            {attachmentData && attachmentData.state === 'dirty' ? (
              <ExclamationIcon />
            ) : (
              <LinkIcon />
            )}
          </span>
          <span className="leading-6" style={{ wordBreak: 'break-all' }}>
            {attachmentData ? attachmentData.name : ''}
          </span>
        </Button>
        <div className="flex items-center justify-center">
          <div className="flex gap-x-4">
            <Button onClick={onConfirm}>Remove</Button>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveAttachmentConfirmModal;
